import httpClient from 'shared/lib/httpClient';

export const updateLanguagePreference = async (payload) => {
  const response = await httpClient.put('/me', payload);
  return response?.data;
};
